import React, { useState, useEffect, useContext } from "react";
import { LuCalculator } from "react-icons/lu";
import { CommonServiceContext } from "../../../services/common/commonService";
import SearchableSelect from "../../../components/SearchableSelect";

const FloatingMessenger = ({ show, onClose }) => {
  const [isOpen, setIsOpen] = useState(false);
  const {
    cities,
    deliveryOrderTypes,
    getReferences,
    deliveryMethods,
    priceCalculation,
  } = useContext(CommonServiceContext);

  const [formData, setFormData] = useState({
    deliveryMethodId: "",
    deliveryOrderTypeId: "",
    estimatePrice: "",
    receiverCityId: "",
    senderCityId: "",
    weight: "",
  });

  const [updatedCities, setUpdatedCities] = useState([]);
  const [updatedDeliveryOrderTypes, setUpdatedDeliveryOrderTypes] = useState(
    []
  );
  const [updatedDeliveryMethods, setUpdatedDeliveryMethods] = useState([]);
  const [selectedDeliveryOrderType, setSelectedDeliveryOrderType] =
    useState("");
  const [selectedDeliveryMethod, setSelectedDeliveryMethod] = useState("");
  const [estimatePrice, setEstimatePrice] = useState("");

  const [selectedCities, setSelectedCities] = useState({
    senderCityName: "",
    receiverCityName: "",
  });

  const fetchReferences = async () => {
    //await getCities();
    getReferences();
  };

  useEffect(() => {
    fetchReferences();
  }, []);

  useEffect(() => {
    if (cities.length != 0) {
      const updatedData = cities.map(({ value, ...rest }) => ({
        name: value,
        ...rest,
      }));
      setUpdatedCities(updatedData);
      //console.log(updatedData);
    }
  }, [cities]);

  useEffect(() => {
    if (deliveryOrderTypes.length != 0) {
      //console.log(deliveryOrderTypes);
      const updatedData = deliveryOrderTypes.map(({ value, ...rest }) => ({
        name: value,
        ...rest,
      }));
      //console.log(updatedData);
      setUpdatedDeliveryOrderTypes(updatedData);
      //console.log(updatedData);
    }
  }, [deliveryOrderTypes]);

  useEffect(() => {
    if (deliveryMethods.length != 0) {
      //console.log(deliveryMethods);
      const updatedData = deliveryMethods.map(({ value, ...rest }) => ({
        name: value,
        ...rest,
      }));
      //console.log(updatedData);
      setUpdatedDeliveryMethods(updatedData);
      //console.log(updated
    }
  }, [deliveryMethods]);

  const handleSelectChange = (val, type) => {
    //console.log([val, type]);
    const city = updatedCities.find((city) => city.name === val);
    //console.log(city);
    if (city) {
      if (type === "sender") {
        // setSender({ ...sender, cityId: city.id });
        setFormData({ ...formData, senderCityId: city.id });
        setSelectedCities({ ...selectedCities, senderCityName: city.name });
      } else {
        // setReceiver({ ...receiver, cityId: city.id });
        setFormData({ ...formData, receiverCityId: city.id });
        setSelectedCities({ ...selectedCities, receiverCityName: city.name });
      }
    }
  };

  const handlDeliveryChange = (selectedOption) => {
    const selectedValue = selectedOption.target.value;
    setSelectedDeliveryOrderType(selectedValue);

    const deliveryOrderType = updatedDeliveryOrderTypes.find(
      (c) => c.name === selectedOption.target.value
    );
    //console.log(deliveryOrderType);
    if (deliveryOrderType) {
      setFormData({ ...formData, deliveryOrderTypeId: deliveryOrderType.id });
    }
    //console.log("Selected Option:", selectedValue);
  };

  const handlDeliveryMethodChange = (selectedOption) => {
    const selectedValue = selectedOption.target.value;
    setSelectedDeliveryMethod(selectedValue);

    const deliveryMethod = updatedDeliveryMethods.find(
      (c) => c.name === selectedOption.target.value
    );
    //console.log(deliveryMethod);
    if (deliveryMethod) {
      setFormData({ ...formData, deliveryMethodId: deliveryMethod.id });
    }
    //console.log("Selected Option:", selectedValue);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    //console.log(formData);
    const isFormValid = Object.values(formData).every((value) => value !== "");

    if (isFormValid) {
      // Call API
      const response = await priceCalculation(formData);
      //console.log(response);
      if (response) {
        const { price } = response;
        //console.log(price);
        setEstimatePrice(`${price} ₾ `);
      }
    }
  };

  const toggleMessenger = () => {
    setIsOpen(!isOpen);
  };

  // const disableWheel = (e) => e.preventDefault();

  return (
    <div className="fixed bottom-15 right-15 z-50">
      {/* Messenger Icon */}
      {/* {!isOpen && (
        <button
          onClick={toggleMessenger}
          className="bg-blue-500 text-white rounded-full w-14 h-14 flex items-center justify-center shadow-lg hover:bg-blue-600 transition"
        >
          <LuCalculator className="w-8 h-8 text-primary" />
        </button>
      )} */}

      {/* Messenger Form */}
      {show && (
        <div className="w-[calc(100vw/6)] bg-white shadow-lg rounded-lg p-4">
          <div className="flex justify-between items-center border-b pb-2 mb-2">
            <h3 className="text-lg font-bold text-gray-700">
              ფასის კალკულაცია
            </h3>
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700"
            >
              ✕
            </button>
          </div>

          <form className="space-y-4" onSubmit={handleSubmit}>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                სერვისი
              </label>
              <select
                onChange={handlDeliveryChange}
                value={selectedDeliveryOrderType}
                className="w-full form-select cursor-pointer rounded-e-md bg-card-color py-[6px] pe-30 text-[13px]/[32px] appearance-none border border-border-color focus:outline-0 focus:border-primary"
              >
                <option value="" disabled defaultValue="">
                  აირჩიეთ
                </option>
                {updatedDeliveryOrderTypes.map((type) => (
                  <option className="option" key={type.id} value={type.name}>
                    {type.name}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">
                გამგზავნის ქალაქი
              </label>
              <SearchableSelect
                options={updatedCities}
                label="name"
                id="senderCityId"
                selectedVal={selectedCities.senderCityName}
                handleChange={(val) => handleSelectChange(val, "sender")}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                მიმღების ქალაქი
              </label>
              <SearchableSelect
                options={updatedCities}
                label="name"
                id="receiverCityId"
                selectedVal={selectedCities.receiverCityName}
                handleChange={(val) => handleSelectChange(val, "receiver")}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                ჩაბარების ტიპი
              </label>
              <select
                onChange={handlDeliveryMethodChange}
                value={selectedDeliveryMethod}
                className="w-full form-select cursor-pointer rounded-e-md bg-card-color py-[6px] pe-30 text-[13px]/[32px] appearance-none border border-border-color focus:outline-0 focus:border-primary"
              >
                <option value="" disabled defaultValue="">
                  აირჩიეთ
                </option>
                {updatedDeliveryMethods.map((type) => (
                  <option key={type.id} value={type.name}>
                    {type.name}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                წონა (კგ)
              </label>
              <input
                type="number"
                min="0.1"
                step={0.1}
                value={formData.weight}
                // onFocus={() => {
                //   window.addEventListener("wheel", disableWheel, {
                //     passive: false,
                //   });
                // }}
                // onBlur={() => {
                //   window.removeEventListener("wheel", disableWheel);
                // }}
                onWheel={(e) => e.target.blur()}
                onChange={(e) =>
                  setFormData({ ...formData, weight: e.target.value })
                }
                className="mt-1 block w-full form-input border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 text-[13px]/[32px]"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">
                ტვირთის შეფასება
              </label>
              <input
                type="number"
                min="0.1"
                step={0.1}
                value={formData.estimatePrice}
                onChange={(e) =>
                  setFormData({ ...formData, estimatePrice: e.target.value })
                }
                className="mt-1 block w-full form-input border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 text-[13px]/[32px]"
              />
            </div>

            <div>
              <label className="block text-md font-medium text-blue-600">
                გადაზიდვის ღირებულება:{" "}
                <span className="text-xl text-red-500">{estimatePrice}</span>
              </label>
            </div>
            <button
              type="submit"
              className="w-full bg-blue-500 text-primary px-4 py-2 rounded-md hover:bg-blue-600 transition"
            >
              გამოთვლა
            </button>
          </form>
        </div>
      )}
    </div>
  );
};

export default FloatingMessenger;
